<script>
import appConfig from "@/app.config";
import axios from 'axios';
import { EventBus } from "@/event-bus";

// 초기세팅
function initialState (){
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    basicInfo: [],
    memberData: {
      idx: 0,
      insertTime: "",
      level: 0,
      mb_name: "",
      mb_id: "",
      mb_nick: "",
    },
  };
}
export default {
  components: {
  },
  data() {
    return initialState();
  },
  watch: {
  },
  created() {
    // 초기실행
    this.first();
  },
  computed: {
  },
  mounted() {  
  },
  methods: {
    // 초기화
    resetWindow: function (){
      Object.assign(this.$data, initialState());
    },
    // 처음실행
    first: function() {
      this.resetWindow();
      // 사용자 정보 가져오자
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      // store에서 정보받기
      this.basicInfo = this.$store.getters.getModal_md
      if (this.basicInfo.worker=="adminChangeLv") {
        this.memberData = this.basicInfo.val
      }
    },
    // 닫기
    hide() {
      this.$store.commit('setModal_mdVal', ''); // store.js 로 닫히니까 정리해주자
      this.$store.commit('setModal_mdWorker', ''); // store.js 로 닫히니까 정리해주자
      this.$bvModal.hide('modal_md');
      // 닫을 때 관리 계정쪽에 리플레쉬 하자
      EventBus.$emit("admin-list", "listRefresh");
    },
    saveMemberData() {
      // 빈값 있으면 알려주자
      if (this.memberData.mb_name =='' || this.memberData.mb_nick =='') {
        alert('빈값이 있습니다. 항목을 다시 확인해주세요')
      } else {
        this.sendMemberLevel()
      }
    },
    deleteMemberData() {
      if (this.memberData.idx == this.login.idx) {
        alert('본인이 본인을 어떻게 삭제해요? 못해요')
      } else {
        if (this.memberData.level > this.login.level) {
          alert('내 권한보다 높은 권한 사용자라서 안되요')
        } else {
          // 사용자에게 삭제 여부를 묻는 confirm 창을 띄웁니다.
          const result = window.confirm("이 사용자를 정말 삭제하시겠어요?");
          if (result) {
            this.sendMemberDelete();
          }
        }
      }
    },
    async sendMemberLevel() {
      try {
        // idx, level, mb_name, mb_nick 4가지 보내주자 m_member_level
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/m_member_level',
          headers: {
            'access-token': this.token
          },
          data: {
            "idx": this.memberData.idx,
            "level": this.memberData.level,
            "mb_nick": this.memberData.mb_nick,
            "mb_name": this.memberData.mb_name,
          },
        })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '정보가 수정되었습니다.'})
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    async sendMemberDelete() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/m_member_delete',
          headers: {
            'access-token': this.token
          },
          data: {
            "idx": this.memberData.idx,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '관리자아이디 삭제 완료했습니다.'})
            this.hide()
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
  }, // methods 종료
  middleware: "authentication",
};
</script>

<template>
  <div v-if="basicInfo.worker=='adminChangeLv'" class="row">
    <div class="col-xl-12">
      <div class="border-bottom p-1 mb-2">
        <div class="p-0">
          <div class="media align-items-center">
            <div class="media-body overflow-hidden">
              <div class="h4">
                <span class="text-dark">
                  <i class="mdi mdi-smart-card-outline text-blue"></i>
                  관리권한 변경
                </span>
              </div>
            </div>
            <a class="" href="javascript:void(0);" @click="hide">
              <div class="btn btn-block p-0">
                <i class="mdi mdi-close display-6 text-secondary"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 본문 -->
    <div class="col-xl-12 mt-2 mb-2">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-12 mb-2">
            <div class="p-1 bg-soft-secondary rounded text-dark text-bold font-size-11">
              <span class="text-danger">*관리레벨 안내</span> <br />
              최고 관리자<b class="text-blue ml-2">(모든 설정가능)</b><br />
              일반 관리자<b class="text-blue ml-2">(일반 게시물만 관리가능)</b> <br />
              승인 대기중<b class="text-blue ml-2">(관리권한 없는 아무것도 안됨)</b> <br />
            </div>
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="level" class="font-size-12">권한등급 <span class="text-danger">*</span></label>
              <div class="position-relative">
                <select id="level" v-model="memberData.level" class="form-control custom-select">
                  <option :value="99">최고 관리자</option>
                  <option :value="98">일반 관리자</option>
                  <option :value="0">승인 대기중</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="mb_nick" class="font-size-12">글쓴이명 <span class="text-danger">*</span> (글쓰기시 보여지는 이름)</label>
              <div class="position-relative">
                <input type="text" v-model="memberData.mb_nick" class="form-control pl-3" name="mb_nick" />
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="mb_name" class="font-size-12">별명또는실명 <span class="text-danger">*</span> (관리자 구분용)</label>
              <div class="position-relative">
                <input type="text" v-model="memberData.mb_name" class="form-control pl-3" placeholder="" name="mb_name" />
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
          
    <!-- 저장 -->
    <div v-if="memberData.mb_id != 'korezn'" class="col-xl-12 mt-2 mb-2">
      <div class="row">
        <div class="col-xl-8 mb-2">
          <b-button @click="saveMemberData()" class="btn btn-md btn-block btn-primary text-bold">
            저장
          </b-button>
        </div>
        <div class="col-xl-4 mb-2">
          <b-button @click="deleteMemberData()" class="btn btn-md btn-block btn-danger text-bold">
            아이디 삭제
          </b-button>
        </div>
      </div>
    </div>
    <div v-else class="col-xl-12 mt-2 mb-2">
      <div class="row">
        <div class="col-xl-12 mb-2">
          <div class="p-1 bg-soft-secondary rounded text-dark text-bold font-size-11">
            개발자는 수정 및 삭제가 불가능합니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
